import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '合规平台识别', path: '/category/compliance' },
    { name: '隐私保护', path: '/category/privacy' },
    { name: '安全访问技巧', path: '/category/safe-access' },
    { name: '法律风险提示', path: '/category/legal-risks' },
    { name: '防诈骗指南', path: '/category/anti-fraud' },
    { name: '病毒防护', path: '/category/virus-protection' },
    { name: '关于我们', path: '/about' },
  ],
  resources: [
    { name: '隐私政策', path: '/about' },
    { name: '使用条款', path: '/about' },
    { name: '免责声明', path: '/about' },
    { name: '联系我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-shield-check-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                安全指南
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              理性认知，安全为先，法律至上。我们致力于为成年用户提供客观、实用的网络安全知识指南。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              内容分类
            </h4>
            <div className="flex flex-wrap gap-2">
              {footerLinks.navigation.slice(1, 7).map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              相关信息
            </h4>
            <div className="flex flex-col gap-2">
              {footerLinks.resources.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 安全指南 · 版权所有
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供教育与参考，不构成法律或专业技术建议
          </p>
        </div>
      </div>
    </footer>
  );
}